import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFactoryResetFailed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 140,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 89.6406,
			cy: 120.66,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118 48.3776C118 45.8716 119.855 43.7526 122.339 43.4214L124.938 43.0749C130.289 42.3615 135.711 42.3615 141.062 43.0749L144.027 43.4702C146.349 43.7798 148.144 45.6597 148.347 47.9932L150.084 67.9669C150.692 74.962 150.432 82.0055 149.308 88.9365L148.681 92.8004C148.288 95.2212 146.198 97 143.745 97H123C120.239 97 118 94.7614 118 92V48.3776Z",
			fill: "url(#paint0_linear_6332_14469)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 122,
			y: 48,
			width: 22,
			height: 29,
			rx: 1,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40.6406,
			cy: 35.6602,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 76,
			y: 28,
			width: 48,
			height: 85,
			rx: 5,
			fill: "url(#paint1_linear_6332_14469)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 100,
			cy: 99,
			r: 6,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 84,
			y: 37,
			width: 30,
			height: 5,
			rx: 2.5,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 84,
			y: 48,
			width: 18,
			height: 5,
			rx: 2.5,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38 54C38 52.3431 39.3431 51 41 51H112C113.657 51 115 52.3431 115 54V74C115 75.6569 113.657 77 112 77H106C104.343 77 103 78.3431 103 80V88.5858C103 89.4767 101.923 89.9229 101.293 89.2929L89.8787 77.8787C89.3161 77.3161 88.553 77 87.7574 77H41C39.3431 77 38 75.6569 38 74V54Z",
			fill: "url(#paint2_linear_6332_14469)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 52,
			cy: 64,
			r: 6,
			stroke: "url(#paint3_linear_6332_14469)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 85,
			cy: 64,
			r: 6,
			stroke: "url(#paint4_linear_6332_14469)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64 57V71",
			stroke: "url(#paint5_linear_6332_14469)",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97 57V71",
			stroke: "url(#paint6_linear_6332_14469)",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73 57V71",
			stroke: "url(#paint7_linear_6332_14469)",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M106 57V71",
			stroke: "url(#paint8_linear_6332_14469)",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M138.333 75.0003C138.333 82.3641 132.364 88.3337 125 88.3337C117.636 88.3337 111.667 82.3641 111.667 75.0003C111.667 67.6365 117.636 61.667 125 61.667C132.364 61.667 138.333 67.6365 138.333 75.0003Z",
			fill: "#DB5543",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M125 67.333C125.552 67.333 126 67.7807 126 68.333V76.333C126 76.8853 125.552 77.333 125 77.333C124.448 77.333 124 76.8853 124 76.333V68.333C124 67.7807 124.448 67.333 125 67.333ZM125 79.333C125.552 79.333 126 79.7807 126 80.333V81.6663C126 82.2186 125.552 82.6663 125 82.6663C124.448 82.6663 124 82.2186 124 81.6663V80.333C124 79.7807 124.448 79.333 125 79.333Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_6332_14469",
				x1: 119.258,
				y1: 44.7966,
				x2: 162.635,
				y2: 71.0703,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_6332_14469",
				x1: 77.8305,
				y1: 32.322,
				x2: 142.918,
				y2: 69.4276,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_6332_14469",
				x1: 40.9364,
				y1: 53.0339,
				x2: 69.8999,
				y2: 109.32,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_6332_14469",
				x1: 46.4576,
				y1: 58.6102,
				x2: 57.1356,
				y2: 69.3898,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_6332_14469",
				x1: 79.4576,
				y1: 58.6102,
				x2: 90.1356,
				y2: 69.3898,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_6332_14469",
				x1: 64.0381,
				y1: 57.7119,
				x2: 65.8255,
				y2: 57.8408,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_6332_14469",
				x1: 97.0381,
				y1: 57.7119,
				x2: 98.8255,
				y2: 57.8408,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_6332_14469",
				x1: 73.0381,
				y1: 57.7119,
				x2: 74.8255,
				y2: 57.8408,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint8_linear_6332_14469",
				x1: 106.038,
				y1: 57.7119,
				x2: 107.826,
				y2: 57.8408,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgFactoryResetFailed);
export { ForwardRef as ReactComponent };
